export const environment = {
    production: false,
    portalLive: true,
    taxAllowed: false,
    version: '1.0.0',
    config: {
        romanianLanguageDataTable: {
            sEmptyTable: 'Niciun rezultat găsit',
            sInfo: 'Afișate de la _START_ până la _END_ din _TOTAL_ înregistrări',
            sInfoEmpty: 'Afișate de la 0 până la 0 din 0 înregistrări',
            sInfoFiltered: '(filtrat din _MAX_ înregistrări)',
            sInfoPostFix: '',
            sInfoThousands: ',',
            sLengthMenu: 'Afișează _MENU_ înregistrări pe pagină',
            sLoadingRecords: 'Încărcare...',
            sProcessing: 'Procesare...',
            sSearch: 'Caută:',
            sZeroRecords: 'Niciun rezultat găsit',
            oPaginate: {
                sFirst: 'Prima',
                sLast: 'Ultima',
                sNext: 'Următoarea',
                sPrevious: 'Anterioară',
            },
        },
        fromTokenValid: 'development.auth-core.webproductionlabs.com',
        tokenKey: 'wpl-staging-cetatean-app-token', // this token is used for every request where is needed
        userKey: 'wpl-staging-cetatean-app-user', // here we find local storage with minimal user data
        storageKey: 'wpl-staging-cetatean', // here we find key for predefined local storage for app functionalities
        copyrightText: '© Copyright 2026 - Primăria Sectorului 4',
        appName: 'Primăria Sectorului 4',
        platformName: 'Platforma Online',
        defaultLNG: 'ro',
        emailRegex:
            '^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$',
        codeSMSRegex: /^[0-9]+$/,
        phoneRegex: '[0-9]{6,20}',
        cnpRegex: '[0-9]{13,13}',
        validatorsAccrossApp: {
            minPassword: 8,
            maxPassword: 50,
            emailMaxLength: 50,
            minStringLength: 2,
            maxStringLength: 60,
            minSmsCodeLength: 1,
            maxSmsCodeLength: 1,
        },
        customNotifications: {
            icons: {
                success: 'success',
                error: 'error',
                info: 'info',
                warning: 'warning',
            },
            headers: {
                success: 'Felicitări!',
                error: 'Atenție!',
                successForm: 'Felicitări!',
            },
            generalMessages: {
                error:
                    'Ne pare rău, dar am întâmpinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.',
                fileErrorMsg:
                    'Ne pare rău, dar fișierul selectat nu a putut fi încărcat. Vă rugăm să reîncercați!',
            },
        },
        loginUrl: '/pages/login',
        continueAppointmentDelayInMinutes: 15,
        continueAppointmentMaxLimit: 4,
        roeidEnabled: true,
    },
    interop: {
        programariCore: {
            basePath: 'https://development.deps-core.webproductionlabs.com/',
            api: {
                cetatean: {
                    uploadFile: 'cetatean/cerere/upload-file',
                    downloadDocumentSolicitare: 'cetatean/cerere/document/',
                    saveMessageSolicitare: 'cetatean/cerere/solicitare-save-message/',
                    viewSolicitare: 'cetatean/cerere/solicitare-view/',
                },
                public: {
                }
            }
        },
        authCore: {
            basePath: 'https://development.auth-core.webproductionlabs.com/',
            user: {
                refreshLogin: 'cetatean/refresh',
                loginUrl: 'cetatean/login',
                resendCode: 'cetatean/cetatean-resend-code',
                confirmCode: 'cetatean/cetatean-confirm-code',
                checkEmailPasswordReset: 'cetatean/reset-password-cnp',
                resendCodePasswordReset: 'cetatean/reset-password-resend-code',
                verifyCodePasswordReset: 'cetatean/reset-verify-code',
                updatePasswordReset: 'cetatean/reset-password-update',
                fileUploadRegister: 'cetatean/upload-file-register',
                registerAccount: 'cetatean/cetatean-register',
                registerCheckCNP: 'cetatean/cetatean-register-check-cnp',
                checkPinRegister: 'cetatean/cetatean-check-pin-register',
                registerAccountInrolat: 'cetatean/cetatean-register',
                resetPINCodeInrolatAccount: 'cetatean/cetatean-reset-pin-code-inrolare',
                findDetails: 'cetatean/user',
                logoutUrl: 'cetatean/logout',
                updatePasswordAccount: 'cetatean/password',
                updateInfoAccount: 'cetatean/profile-update',
                addressSave: 'cetatean/address/save',
                addressUpdate: 'cetatean/address/update',
                addressList: 'cetatean/address/list',
                addressDelete: 'cetatean/address/',
                sendSolicitare: 'cetatean/suport-online',
                sendSolicitareInsideAcc: 'cetatean/authenticated-suport-online',
            },
            ocr: {
                processCi: 'api/process-ci',
                processCert: 'api/process-cert',
            },
            announces: 'cetatean/platform/announces/list/', // + {slug}
            article: {
                list: 'cetatean/article/list',
                find: 'cetatean/article/find/' // + {id}
            },
            bulevart: {
                getGallery: 'cetatean/bulevart/list-gallery'
            },
            contact: 'contact',
            solicitare: {
                storeURL: 'cetatean/solicitare/store',
                updateURL: 'cetatean/solicitare/store',
                listDT: 'cetatean/solicitare/list-dt',
                viewSolicitare: 'cetatean/cerere/solicitare-view/',
                downloadDocumentSolicitare: 'cetatean/cerere/document/',
                saveMessageSolicitare: 'cetatean/cerere/solicitare-save-message/',
                findDraft: 'cetatean/solicitare/findDraft/'
            },
            beneficiar: {
                listUrl: 'cetatean/beneficiar/list',
                listValidatedUrl: 'cetatean/beneficiar/list-validated',
                saveUrl: 'cetatean/beneficiar/save',
                updateUrl: 'cetatean/beneficiar/update',
                removeUrl: 'cetatean/beneficiar/remove',
                findUrl: 'cetatean/beneficiar/find/',
            },
            tari: {
                getTari: 'cetatean/country/list',
                getTariActive: 'cetatean/country/list/active',
            },
            judete: {
                getJudete: 'cetatean/judet/list',
                getJudeteActive: 'cetatean/judet/list/active',
                getJudetePublic: 'cetatean/judet/list/public',
            },
            localitati: {
                getLocalitati: 'cetatean/localitate/list',
                getLocalitatiActive: 'cetatean/localitate/list/active',
                getLocalitatiPublic: 'cetatean/localitate/list/public',
            },
            documenteleMele: {
                getDocumenteleMeleDT: 'cetatean/citizen-documents/list-dt',
                fileDownload: 'cetatean/citizen-documents/download/', // + id_document/id_fisier
                fileDownloadLink: 'cetatean/citizen-documents/download-link/', // + id_document/id_fisier -> link semnat temporar
            },
            institutii: {
                downloadFile: 'public/institutii/documente/download/', // + id
                declaratii: {
                    getYears: 'public/institutii/documente/years/', // + {institution}
                    getDeclaratii: 'public/institutii/documente/declaratii/' // + {institution}/{year}
                },
                cariera: {
                    getDocumente: 'public/institutii/documente/cariera/', // + {institution}
                },
                achizitii: {
                    getYears: 'public/institutii/documente/achizitii/years/', // + {institution}
                    getDocumente: 'public/institutii/documente/achizitii/documents/' // + {institution}/{year}
                }
            },
            programari: {
                getModuleList: 'cetatean/programari/module/list',
                getLocatiiList: 'cetatean/programari/module-locations/list/', // + id_modul
                getServiciiList: 'cetatean/programari/module-locations-services/list/', // + id_modul/id_locatie
                getTipuriProblemaList: 'cetatean/programari/services-problem-types/list/', // + id_serviciu
                getTipuriProgramList: 'cetatean/programari/find-program-type-by-configuration/', // + id_modul/id_locatie/id_serviciu
                getFullDays: 'cetatean/programari/get-full-days/', // + id_modul/id_locatie/id_serviciu/id_program_type
                getZileLibere: 'cetatean/programari/zile-libere/list',
                getAvailableHours: 'cetatean/programari/get-available-slots',
                makeAppointment: 'cetatean/programari/make-appointment',
                resetAppointment: 'cetatean/programari/reset-appointment',
                storeProgramare: 'cetatean/programari/store-programare',
                resendSms: 'cetatean/programari/programare-resend-code',
                confirmSms: 'cetatean/programari/programare-confirm-code',
                anulareProgramare: 'cetatean/programari/anulare-programare',
                findProgramare: 'cetatean/programari/find-programare',
                checkProgramareByCnp: 'cetatean/programari/check-appointment',
            }
        },
        urbanismCore: {
            basePath: 'https://development.urb-core.webproductionlabs.com/',
            api: {
                cerere: {
                    store: 'cetatean/cerere/store',
                    printCerere: 'cetatean/cerere-precompletare/print/', // + {slug}
                    fileUpload: 'cetatean/cerere/upload-file',
                    saveMessageSolicitare: 'cetatean/cerere/solicitare-save-message/',
                    viewSolicitare: 'cetatean/cerere/solicitare-view/',
                    downloadDocumentSolicitare: 'cetatean/cerere/document/',
                    storeDraft: 'cetatean/solicitare/storeDraft'
                },
            },
            platform: {
                faq: 'cetatean/platform/faq/list/', // + {slug}
                content: 'cetatean/platform/content/list/', // + {slug}
                announces: 'cetatean/platform/announces/list/', // + {slug} // old, deprecated
            },
            registre: {
                getRegistreDT: 'registru/list-dt',
                getRegistre: 'document-oficial-registru/list',
            }
        },
        paymentsCore: {
            basePath: 'https://development.pay-core.webproductionlabs.com/',
            api: {
                payments: {
                    requestPayment: 'cetatean/mobile-payment-request-v2',
                    getTax: 'cetatean/get-taxes-cetatean-v2',
                    processPaymentsRecurente: 'api/process-payments-recurente/',
                    getCards: 'cetatean/get-cards',
                    removeCard: 'cetatean/remove-card/',
                    getTipuriAmenzi: 'cetatean/payments/tipuri-amenzi-list',
                    checkSoldAmendaToPay: 'cetatean/payments/tipuri-amenzi-interogare',
                    processPaymentRecurentaAmenda:
                        'cetatean/payments/payment-recurenta-amenda/',
                    requestPaymentAmenda: 'cetatean/payments/request-payment-amenda',
                    getTipuriTaxeNedebitate: 'cetatean/payments/tipuri-taxe-nedebitate-list',
                    checkSoldTaxeNedebitateToPay:
                        'cetatean/payments/tipuri-taxe-nedebitate-interogare',
                    requestPaymentTaxeNedebitate:
                        'cetatean/payments/request-payment-taxe-nedebitate',
                    processPaymentRecurentaTaxeNedebitate:
                        'cetatean/payments/payment-recurenta-taxe-nedebitate/',
                    exportPayment: 'cetatean/payments/export-payment-details/',
                },
                announcements: {
                    getAnnouncements: 'api/announcements/',
                },
                public: {
                    checkCUI: 'validate-cui',
                }
            },
        },
        dgitlCore: {
            basePath: 'https://development.dgitl-core.webproductionlabs.com/',
            api: {
                cetatean: {
                    storeForm: 'cetatean/dgitl/storeForm',
                    listSolicitari: 'cetatean/dgitl/solicitari-list',
                    initializeForm: 'cetatean/dgitl/getFormInit/',
                    viewSolicitare: 'cetatean/dgitl/solicitare-view/',
                    saveMessageSolicitare: 'cetatean/dgitl/solicitare-save-message/',
                    saveSolicitareCertificatFiscal:
                        'cetatean/dgitl/process-certificat-fiscal-request',
                    cfGetMatricole: 'cetatean/dgitl/cf-get-matricole',

                    uploadFileRegister: 'cetatean/upload-file-register',
                    uploadFileRegisterBase64: 'cetatean/upload-file-register-base64',
                    downloadDocumentSolicitare: 'cetatean/dgitl/document/',

                    announcements: {
                        getAnnouncements: 'cetatean/dgitl/announcements/',
                    },
                    downloadDeclaratieTSDU: 'cetatean/dgitl/downloadDeclaratieTSDU'
                },
                operator: {
                    solicitari: 'api/dgitl/storeForm',
                },
                public: {
                    initializeForm: 'dgitl/getFormInit/',
                    storeForm: 'dgitl/storeForm',
                    uploadFileRegister: 'upload-file-register',
                    downloadFile: 'download-file/',
                    downloadDeclaratieTSDU: 'dgitl/downloadDeclaratieTSDU'
                },
            },
        },
        autcomCore: {
            basePath: 'https://development.autcom-core.webproductionlabs.com/',
            api: {
                cetatean: {
                    store: 'cetatean/cerere/store',
                    uploadFile: 'cetatean/cerere/upload-file',
                    downloadDocumentSolicitare: 'cetatean/cerere/document/',
                    saveMessageSolicitare: 'cetatean/cerere/solicitare-save-message/',
                    viewSolicitare: 'cetatean/cerere/find/',
                },
                public: {
                    store: 'cerere/store',
                    uploadFile: 'cerere/upload-file',
                    getStreet: 'cetatean/strazi/get_street/',
                    appLocked: 'app-locked',
                }
            },
            registre: {
                getRegistreDT: 'registru-public',
                getRegistre: 'registru-public-types-list',
                getRegistreValability: 'registru-public-get-valability-years',
            }
        },
        asistentaCore: {
            basePath: 'https://development.dgaspc-core.webproductionlabs.com/',
            api: {
                cerere: {
                    store: 'cetatean/cerere/store',
                    printCerere: 'cetatean/cerere-precompletare/print/', // + {slug}
                    fileUpload: 'cetatean/cerere/upload-file',
                    saveMessageSolicitare: 'cetatean/cerere/solicitare-save-message/',
                    viewSolicitare: 'cetatean/cerere/solicitare-view/',
                    downloadDocumentSolicitare: 'cetatean/cerere/document/',
                    storeDraft: 'cetatean/solicitare/storeDraft'
                },
            },
            // registre: {
            //     getRegistreDT: 'registru/list-dt',
            //     getRegistre: 'document-oficial-registru/list',
            // }
        },
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
